import classNames from 'classnames';
import * as React from 'react';
import { useState, useMemo, useCallback } from 'react';
import { Button } from 'Views/Components/Button/Button';

export interface IAccordionConfig {
	title: string | React.ReactNode;
	component: React.ReactNode;
	key: string;
}

function AccordionSection({ title, component }: IAccordionConfig) {
	const [expanded, setExpanded] = useState(false);



	const contentClassName = classNames('accordion__info', {
		'accordion__info--expanded': expanded,
		'accordion__info--collapsed': !expanded,
	});

	return (
		<section className={expanded ? 'accordion active' : 'accordion'}>
			<Button
				className="accordion__title"
				icon={{ icon: 'chevron-up', iconPos: 'icon-right' }}
				onClick={() => setExpanded(prev => !prev)}>
				{title}
			</Button>
			<div className={contentClassName}>{expanded ? component : null}</div>
		</section>
	);
}

export interface IAccordionGroupProps {
	accordions: Array<IAccordionConfig>;
}

export default function AccordionGroup({ accordions }: IAccordionGroupProps) {
	return (
		<div className="accordion-group">
			{accordions.map(accordion => (
				<AccordionSection  {...accordion} />
			))}
		</div>
	);
}